<style lang="scss" scoped>
.login {
    height: 100%;
    background: url('../static/projectImg/login/login_bgc.jpg') no-repeat;
    position: relative;
    background-size: 100% 100%;
}
.login-form {
    width: 285px;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
}
.logo-box {
    text-align: center;
}
.logo {
    width: 48px;
    height: 45px;
    /*background-color: gray;*/
    margin: 0 auto;
    margin-bottom: 50px;
}
.label {
    color: #fff;
}
.verification {
    position: absolute;
    right: 4px;
    bottom: 8px;
    width: 68px;
    height: 22px;
    border-left: 1px solid #eee;
    cursor: pointer;
}
    .login-btn{
        width: 285px;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: #ffffff;
        background-image: linear-gradient(rgb(90,156,248), rgb(144,190,253));
        border-radius: 16px;
        cursor: pointer;
        margin-bottom: 40px;
    }
    .logo-box-text{
        text-align: center;
        color: #ffffff;
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 30px;
    }
    .login-text-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .box-forget{
        color: #ffffff;
        font-size: 12px;
        text-decoration:underline;
        cursor: pointer;
    }
    .login-bottom-text{
        position: fixed;
        bottom: 100px;
        left: 0px;
        width: 100%;
        text-align: center;
        font-size: 12px;
        color: #ffffff;
    }
    .err-text{
        height: 15px;
        color: #F56C6C;
        font-size: 12px;
        margin-bottom: 4px;
    }
</style>

<template>
    <div class="login">
        <div class="login-form">
            <div class="logo-box">
                <!-- <img src="../static/projImg/logo.svg" alt="" class="logo"> -->
            </div>
            <template v-if="!reSetPwd">
                <div class="logo-box-text">Log In</div>
                <el-form :model="ruleForm" status-icon :rules="rules"  ref="ruleForm" class="demo-ruleForm" hide-required-asterisk :validate-on-rule-change="false">
                    <el-form-item prop="pass" label="账号" ref="pass">
                        <el-input type="text" v-model="ruleForm.pass" autocomplete="off" placeholder="账号" @focus="clearMsgErr('pass')"></el-input>
                    </el-form-item>
                    <el-form-item  prop="checkPass" label="密码" ref="checkPass">
                        <el-input type="password" show-password v-model="ruleForm.checkPass" autocomplete="off" placeholder="密码" @focus="clearMsgErr('checkPass')"></el-input>
                    </el-form-item>
                    <el-form-item  prop="age" class="test" label="验证码" ref="age">
                        <el-input v-model="ruleForm.age" placeholder="验证码" @focus="clearMsgErr('age')"></el-input>
                        <img :src="imgSrc" alt="" @click="refreshimg"  class="verification">
                    </el-form-item>
                </el-form>
                <div class="err-text">{{msgErr}}</div>
                <el-button class="login-btn" style="text-align: center;" :loading="true" @click.stop="submitForm('ruleForm')">
                    登录
                    <!--<el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>-->
                </el-button>
                <div class="login-text-box">
                    <!--<div class="box-forget">Forget Password</div>-->
                </div>
            </template>
            <template v-if="reSetPwd">
                <div class="logo-box-text">Reset Password</div>
                <el-form :model="ReSetruleForm" status-icon :rules="ReSetruleFormrules"   ref="ReSetruleForm" class="demo-ruleForm" hide-required-asterisk :validate-on-rule-change="false">
                    <el-form-item prop="pass" label="密码" ref="pass">
                        <el-input type="password" show-password v-model="ReSetruleForm.pass" autocomplete="off" placeholder="密码" @focus="clearMsgErr('pass')"></el-input>
                    </el-form-item>
                    <el-form-item  prop="checkPass" label="确认密码" ref="checkPass">
                        <el-input type="password" show-password v-model="ReSetruleForm.checkPass" autocomplete="off" placeholder="确认密码" @focus="clearMsgErr('checkPass')"></el-input>
                    </el-form-item>
                </el-form>
                <div class="err-text">{{msgErr}}</div>
                <div class="login-btn" style="text-align: center;" @click.stop="ResubmitForm('ReSetruleForm')">重置</div>
                <div class="login-btn" style="text-align: center;" @click.stop="cancleRe('ReSetruleForm')">返回</div>
            </template>
        </div>
        <div class="login-bottom-text">© 2020 Linklogis International Company Limited  |  Terms & Conditions</div>
        <template v-if="agreementShow">
            <serviceGreementDialog :show="agreementShow" :pdfUrl="pdfUrl" @close="closePdf" @sure="sureSign"></serviceGreementDialog>
        </template>

    </div>
</template>

<script>
    // import serviceGreementDialog from '@/components/serviceGreementDialog/index.vue'
    export default {
        name:'login',
        components: {
            // serviceGreementDialog
        },
        data (){

            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ReSetruleForm.pass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    pass: '',
                    checkPass: '',
                    age: ''
                },
                rules: {
                    pass: [
                        {  required: true,message: '请输入账号', trigger: 'submit' }
                    ],
                    checkPass: [
                        { required: true, message: '请输入密码', trigger: 'submit' }
                    ],
                    age: [

                        { required: true, message: '请输入验证码', trigger: 'submit' }
                    ]
                },
                ReSetruleForm:{
                    pass: '',
                    checkPass: '',
                },
                ReSetruleFormrules: {
                    pass: [
                        {  required: true,message: '请输入账号', trigger: 'submit' }
                    ],
                    checkPass: [
                        { validator: validatePass2, trigger: 'submit' }
                    ],

                },
                imgSrc:'',
                show: false,
                reSetPwd:false, //重置密码
                msgErr:'',
                tokenUuid:"",
                username:'',
                agreementShow:false, //协议显示
                pdfUrl:'',
                loading: false,
            }
        },
        mounted:function(){
            sessionStorage.clear()
            this.refreshimg()
            this.ruleForm.pass = this.$route.query.userName || ''
        },
        methods:{
            closePdf(){
                this.agreementShow =false //协议显示
                this.pdfUrl=''
            },
            //确认签署
            sureSign(){
                let _this = this
                _this.$http.post(
                    `/kj-idd/home/signPlatformAgreement`,
                ).then(function(data){
                    _this.$router.push('/home');
                },function(response){

                })
            },
            //获取协议
            async getAgm(){
                let _this = this
                let result = await _this.$http.post(
                    `/kj-idd/home/queryPlatformAgreementSignStatus`,
                ).then(function(data){
                    let url = data.data.url || ''
                    if(!url){
                        return false
                    }else{
                        //需要签署
                        _this.agreementShow = true
                        _this.pdfUrl = url
                        return true
                    }

                },function(response){
                    return true
                })
                return result
            },
            cancleRe(formName){
                // debugger
                this.$refs[formName].resetFields();
                this.reSetPwd = false

            },
            clearMsgErr(formName){
                this.msgErr = ''
                if(typeof formName == "string" ){
                    this.$refs[formName].clearValidate();
                }

            },
            refreshimg(){
                var timestamp=new Date().getTime()
                this.imgSrc =  "/kj-sso/captcha/code/get?timestamp="+timestamp
            },
            ResubmitForm(formName){

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // alert('submit!');
                        this.initPwd()
                        // this.cancleRe('ReSetruleForm')
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            initPwd(){
                let _this = this
                let password  = this.ReSetruleForm.pass
                let confirmPassword  = this.ReSetruleForm.checkPass
                _this.$http.post(
                    `/kj-sso/account/initPwd?confirmPassword=${confirmPassword}&password=${password}&tokenUuid=${_this.tokenUuid}&userName=${_this.username}`,{},{handingResponseErrMsg:true}
                ).then(function(data){
                    var code = data.data.code;
                    if(code == "200") {
                        _this.cancleRe('ReSetruleForm')
                        _this.ruleForm.checkPass = ''
                        _this.ruleForm.age = ''
                        _this.refreshimg()
                    } else {
                        _this.refreshimg()
                        _this.msgErr = data.body.msg || data.body.message || '暂无响应，请联系管理员'
                    }
                },function(response){
                    _this.refreshimg()
                    _this.msgErr = response || '暂无响应，请联系管理员'
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // alert('submit!');
                        // this.login() //非加密
                        this.logon() //加密登录
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            //获取公钥
            async getPubKey(){
                let _this = this
                let result = ''
                result = await _this.$http.post(
                    `/kj-sso/account/getPublicKey`
                ).then(function(data){
                    var code = data.data.code;
                    if(code == "200") {
                        return data.body.data
                    } else {

                        // _this.$llsAlert({text: data.body.msg || data.body.message});
                        _this.msgErr =  data.body.msg || data.body.message
                        return ''
                    }
                },function(response){

                    // _this.$llsAlert({text: response});
                    _this.msgErr = response
                    return ''
                })
                return result
            },
            //加密登录
            async logon(data){
                let getPublicKey = ''
                getPublicKey = await this.getPubKey()
                if(!getPublicKey){
                    return
                }
                var _this = this;
                var userName = this.ruleForm.pass || "";
                var password = this.encryptedData(this.ruleForm.checkPass,getPublicKey) || "";
                var picCheckCode = this.ruleForm.age || "";
                _this.username = userName
                // this.$router.push('/home');
                // _this.state = "";
                _this.$http.post(
                    `/kj-sso/account/logon`,{userName,password,picCheckCode}
                ).then(function(data){
                    var code = data.data.code;
                    if(code == "200") {
                        // sessionStorage.setItem("objUser", JSON.stringify(data.data.data))
                        // if(window.location.href.includes('localhost')){
                        //     document.cookie = "llskj="+data.data.data.sessionId;
                        // }
                        // _this.$router.push('/home');
                        // // _this.getUserInfo()
                        let result = data.data.data || {}
                        if(!result.tokenUuid){

                            sessionStorage.setItem("objUser", JSON.stringify(data.data.data))
                            if(window.location.href.includes('localhost')){
                                document.cookie = "llskj="+data.data.data.sessionId;
                            }
                            // _this.$router.push('/companyChoose');
                            _this.$router.push('/kycFileCN');
                            //判断是否需要签署
                            // let flag = await _this.getAgm()
                            // if(flag){
                            //     //需要签署
                            // }else {
                            //     //已经签署了
                            //     _this.$router.push('/home');
                            // }

                            // _this.getUserInfo()
                        }else {
                            //存在tokenUuid需要重置密码
                            _this.tokenUuid = result.tokenUuid
                            _this.reSetPwd = true
                        }
                    } else {
                        _this.refreshimg()
                        _this.msgErr = data.body.msg || data.body.message || '暂无响应，请联系管理员'
                        // _this.state = "loginFail";
                        // _this.$llsAlert({text: data.body.msg || data.body.message});
                    }
                },function(response){
                    _this.refreshimg()
                    _this.msgErr = response || '暂无响应，请联系管理员'
                    // _this.state = "loginFail";
                    // _this.$llsAlert({text: response});
                })
            },
            //登录
            login : function(data){
                    this.loading =true;
                var _this = this;
                var username = this.ruleForm.pass || "";
                var password = this.ruleForm.checkPass || "";
                var vericode = this.ruleForm.age || "";
                this.username = this.ruleForm.pass
                // this.$router.push('/home');
                // _this.state = "";
                _this.$http.post(
                    "/kj-sso/account/login?userName="+username+"&password="+password+"&picCheckCode="+vericode,{},{handingResponseErrMsg:true}
                ).then(async function(data){
                    var code = data.data.code;
                    if(code == "200") {
                        // sessionStorage.setItem("objUser", JSON.stringify(data.data.data))
                        // if(window.location.href.includes('localhost')){
                        //     document.cookie = "llskj="+data.data.data.sessionId;
                        // }
                        // _this.$router.push('/home');
                        // // _this.getUserInfo()
                        let result = data.data.data || {}
                        if(!result.tokenUuid){

                            sessionStorage.setItem("objUser", JSON.stringify(data.data.data))
                            if(window.location.href.includes('localhost')){
                                document.cookie = "llskj="+data.data.data.sessionId;
                            }
                            _this.$router.push('/companyChoose');
                            //判断是否需要签署
                            // let flag = await _this.getAgm()
                            // if(flag){
                            //     //需要签署
                            // }else {
                            //     //已经签署了
                            //     _this.$router.push('/home');
                            // }

                            // _this.getUserInfo()
                        }else {
                            //存在tokenUuid需要重置密码
                            _this.tokenUuid = result.tokenUuid
                            _this.reSetPwd = true
                        }
                    } else {
                        _this.refreshimg()
                        _this.msgErr = data.body.msg || data.body.message || '暂无响应，请联系管理员'
                        // _this.state = "loginFail";
                        // _this.$llsAlert({text: data.body.msg || data.body.message});
                    }
                },function(response){
                    _this.refreshimg()
                    _this.msgErr = response || '暂无响应，请联系管理员'
                    // _this.state = "loginFail";
                    // _this.$llsAlert({text: response});
                }).finally(()=>{
                    this.loading=false
                })
            },
        }
    }
</script>